import apiService from './apiService';

// Get all shift rosters
export const getShiftRosters = async (page: number = 1, search = '') => {
  try {
    const params = new URLSearchParams({
      page: String(page),
    });

    if (search) params.append('filter[search]', search);

    const response = await apiService.get(`/shift-rosters?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching shift rosters:', error);
    throw error;
  }
};

// Get single shift roster
export const getShiftRosterDetail = async (id: number | string) => {
  try {
    const response = await apiService.get(`/shift-rosters/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching shift roster detail:', error);
    throw error;
  }
};

// Create shift roster
export const createShiftRoster = async (payload: any) => {
  try {
    const response = await apiService.post('/shift-rosters', payload);
    return response.data;
  } catch (error) {
    console.error('Error creating shift roster:', error);
    throw error;
  }
};

// Delete shift roster
export const deleteShiftRoster = async (id: number | string) => {
  try {
    const response = await apiService.delete(`/shift-rosters/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting shift roster:', error);
    throw error;
  }
};

// Update roster cell
export const updateShiftRosterCell = async (payload: any) => {
  try {
    const response = await apiService.post('/shift-rosters/update-cell', payload);
    return response.data;
  } catch (error) {
    console.error('Error updating shift roster cell:', error);
    throw error;
  }
};

// =========================
// Shift Roster Groups
// =========================

// Get all groups
export const getShiftRosterGroups = async () => {
  try {
    const response = await apiService.get('/shift-roster-groups');
    return response.data;
  } catch (error) {
    console.error('Error fetching shift roster groups:', error);
    throw error;
  }
};

// Get single group
export const getShiftRosterGroupDetail = async (id: number | string) => {
  try {
    const response = await apiService.get(`/shift-roster-groups/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching shift roster group detail:', error);
    throw error;
  }
};

// Create group
export const createShiftRosterGroup = async (payload: any) => {
  try {
    const response = await apiService.post('/shift-roster-groups', payload);
    return response.data;
  } catch (error) {
    console.error('Error creating shift roster group:', error);
    throw error;
  }
};

// Update group
export const updateShiftRosterGroup = async (id: number | string, payload: any) => {
  try {
    const response = await apiService.put(`/shift-roster-groups/${id}`, payload);
    return response.data;
  } catch (error) {
    console.error('Error updating shift roster group:', error);
    throw error;
  }
};

// Delete group
export const deleteShiftRosterGroup = async (id: number | string) => {
  try {
    const response = await apiService.delete(`/shift-roster-groups/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting shift roster group:', error);
    throw error;
  }
};

// =========================
// Shift Roster Duty Codes
// =========================

// Get all duty codes
export const getShiftRosterDutyCodes = async () => {
  try {
    const response = await apiService.get('/shift-roster-duty-codes');
    return response.data;
  } catch (error) {
    console.error('Error fetching shift roster duty codes:', error);
    throw error;
  }
};

// Get single duty code
export const getShiftRosterDutyCodeDetail = async (id: number | string) => {
  try {
    const response = await apiService.get(`/shift-roster-duty-codes/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching shift roster duty code detail:', error);
    throw error;
  }
};

// Create duty code
export const createShiftRosterDutyCode = async (payload: any) => {
  try {
    const response = await apiService.post('/shift-roster-duty-codes', payload);
    return response.data;
  } catch (error) {
    console.error('Error creating shift roster duty code:', error);
    throw error;
  }
};

// Update duty code
export const updateShiftRosterDutyCode = async (id: number | string, payload: any) => {
  try {
    const response = await apiService.put(`/shift-roster-duty-codes/${id}`, payload);
    return response.data;
  } catch (error) {
    console.error('Error updating shift roster duty code:', error);
    throw error;
  }
};

// Delete duty code
export const deleteShiftRosterDutyCode = async (id: number | string) => {
  try {
    const response = await apiService.delete(`/shift-roster-duty-codes/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting shift roster duty code:', error);
    throw error;
  }
};

// =========================
// Shift Roster Workflow
// =========================

// Notify Approval
export const notifyShiftRosterApproval = async (id: number | string, payload?: any) => {
  try {
    const response = await apiService.post(`/shift-rosters/${id}/notify-approve`, payload);
    return response.data;
  } catch (error) {
    console.error('Error notifying shift roster approval:', error);
    throw error;
  }
};

// Mark Approved
export const markShiftRosterApproved = async (id: number | string, payload?: any) => {
  try {
    const response = await apiService.post(`/shift-rosters/${id}/mark-approved`, payload);
    return response.data;
  } catch (error) {
    console.error('Error marking shift roster approved:', error);
    throw error;
  }
};

// Reject Shift Roster
export const rejectShiftRoster = async (id: number | string, payload?: any) => {
  try {
    const response = await apiService.post(`/shift-rosters/${id}/reject`, payload);
    return response.data;
  } catch (error) {
    console.error('Error rejecting shift roster:', error);
    throw error;
  }
};

// Download approved shift roster
export const downloadShiftRoster = async (id: number | string) => {
  try {
    const response = await apiService.get(`/shift-rosters/${id}/download`, {
      responseType: 'blob',
    });

    return response.data;
  } catch (error) {
    console.error('Error downloading shift roster:', error);
    throw error;
  }
};

// ================= OPERATION MANAGER APIs =================
export const getOperationManagers = async () => {
  try {
    const response = await apiService.get('/users?filter[user_type_id]=9');
    return response.data;
  } catch (error) {
    console.error('Error fetching Operation managers:', error);
    throw error;
  }
};
